import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ReversaPagoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodosReversos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: reversa_pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          reversa_pago {
            obtenerTodosReversos(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  cliente_proveedor_rut
                  cliente_proveedor_nombre
                  movimiento_pago_codigo
                  motivo
                  monto
                  fecha
                  rut_usuario
                  nombre_usuario
                  pago_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.reversa_pago.obtenerTodosReversos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: reversa_pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          reversa_pago {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  cliente_proveedor_rut
                  cliente_proveedor_nombre
                  movimiento_pago_codigo
                  motivo
                  monto
                  fecha
                  rut_usuario
                  nombre_usuario
                  pago_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.reversa_pago.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: reversa_pagoInputType) {
          reversa_pago {
            obtenerExcel(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }        
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.reversa_pago.obtenerExcel;
            callback({ mensajes, respuesta });
        });
    }
    obtenerRervesoSegunCodigo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: reversa_pagoInputType) {
          reversa_pago {
            obtenerRervesoSegunCodigo(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                cliente_proveedor_rut
                cliente_proveedor_nombre
                movimiento_pago_codigo
                motivo
                monto
                fecha
                rut_usuario
                nombre_usuario
                pago_codigo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.reversa_pago.obtenerRervesoSegunCodigo;
            callback({ mensajes, respuesta });
        });
    }
    guardarReversa(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: reversa_pagoInputType) {
          reversa_pago {
            guradarReversa(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                fecha
                motivo
                monto
                movimiento_pago_codigo
                rut_usuario
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.reversa_pago.guradarReversa;
            callback({ mensajes, respuesta });
        });
    }
}
ReversaPagoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReversaPagoService_Factory() { return new ReversaPagoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ReversaPagoService, providedIn: "root" });
